import { Image } from "@ui/components/core/Image";
import { ImageSizes } from "@ui/lib/image";

export const Phone = () => {
  return (
    <div className='flex items-center justify-center'>
      <div className='relative'>
        <Image
          alt='ElevenLabs Mobile App'
          className='z-1 w-[500px] animate-fade-in-delayed'
          fit='contain'
          height={2581}
          loading='eager'
          priority
          sizes={ImageSizes.FULL_HALF_ON_LG}
          src='/assets/images/hero/mobile-app/phone.png'
          width={1635}
        />
        <Image
          alt='Influencer selfie'
          className='absolute bottom-32 left-10 z-1 h-auto w-2/5 -rotate-12 animate-fade-in-delayed rounded-[36px] shadow-md'
          fit='contain'
          height={1137}
          loading='eager'
          priority
          sizes={ImageSizes.FULL_1_3_ON_LG}
          src='/assets/images/hero/mobile-app/image-1.png'
          width={770}
        />
        <Image
          alt='Influencer video preview'
          className='absolute bottom-10 right-10 z-1 h-auto w-3/5 rotate-12 animate-fade-in-delayed-2 rounded-[30px] shadow-md'
          fit='contain'
          height={1481}
          loading='eager'
          priority
          sizes={ImageSizes.FULL_1_3_ON_LG}
          src='/assets/images/hero/mobile-app/image-2.png'
          width={997}
        />
      </div>
    </div>
  );
};
